module.exports = __webpack_public_path__ + "img/q1.9fda768a.png";